import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { useLogout } from "@monorepo/hooks";
import { LogoutIcon, NotificationsIcon } from "@monorepo/icons";
import { useClientQuery } from "@monorepo/services/api/auth";
import theme, { iconsSizes } from "@monorepo/styles/theme";
import { Box, IconButton, Tooltip } from "@mui/material";

import { NotificationsMenuLink } from "../Menu/NotificationsMenuLink/NotificationsMenuLink";

export const Header: React.FC = () => {
  const { data: client } = useClientQuery();
  const history = useHistory();
  const { t } = useTranslation();
  const { logout } = useLogout();

  return (
    <Box
      sx={{
        display: "grid",
        justifyContent: "flex-end",
        gridTemplateColumns: "repeat(3, max-content)",
        columnGap: theme.spacing(1),
        height: {
          md: "72px",
          xxl: "100px",
        },
        alignItems: "center",
      }}
    >
      <Box
        component="span"
        sx={{
          color: theme.palette.nobelGray.main,
          marginRight: theme.spacing(3),
          paddingY: theme.spacing(1),
          "&:hover": {
            color: theme.palette.text.secondary,
            background: "transparent",
            cursor: "pointer",
            borderRadius: "5px",
          },
        }}
        onClick={() => history.push(routeConfig.dashboard.profile.personal)}
      >
        {client?.name} {client?.surname}
      </Box>
      <NotificationsMenuLink hideTitle>
        <Tooltip title={t("notifications.tooltip")}>
          <IconButton
            onClick={() => {
              ReactGA.event("notifications");
            }}
            aria-label={t("navigation.notifications")}
            sx={{
              "&:hover": {
                "& path": {
                  stroke: theme.palette.shuttleGray.main,
                },
              },
            }}
          >
            <NotificationsIcon
              sx={{
                display: "inherit",
                fontSize: iconsSizes.large,
                stroke: theme.palette.nobelGray.main,
              }}
            />
          </IconButton>
        </Tooltip>
      </NotificationsMenuLink>
      <Tooltip title={t("common.logout_tooltip")}>
        <IconButton
          aria-label={t("common.logout")}
          sx={{
            marginRight: theme.spacing(3),
            "&:hover": {
              "& path": {
                stroke: theme.palette.shuttleGray.main,
              },
            },
          }}
          onClick={logout}
        >
          <LogoutIcon
            sx={{
              display: "inherit",
              fontSize: iconsSizes.large,
              stroke: theme.palette.nobelGray.main,
            }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
